import React, { Component } from "react";
import { Button, Input, Label, Row, Col } from "reactstrap";
import axios from "axios";
import { URL_PreScheduling } from "../Services/preSchedulingService";
import { FaSpinner } from "react-icons/fa";
import { FiMapPin } from "react-icons/fi";
import { FiSearch } from "react-icons/fi";
import { FiClock } from "react-icons/fi";
import { FiCalendar } from "react-icons/fi";
import styles from "./SelectServices.styles";
import "./SelectServices.css"; // Importa estilos e animações
import { ScheduleOrContinueModal } from "../../common/components/utils/customModal";
export default class SelectServices extends Component {
  constructor(props) {
    super(props);
    const myParam = window.location.pathname.split("/")[1];
    // ref para o container da lista e estado para controlar se estamos no fim da lista
    this.listContainerRef = React.createRef();
    this.filterTimeout = null;
    this.state = {
      listProcedures: [],
      originalProcedures: [],
      myParam: myParam,
      navigate: false,
      loading: true,
      nameProcedure: "",
      listChecked: [],
      isAtEnd: false,
      showActionCard: false, // Mostra card de ação após seleção
      lastSelectedService: "", // Nome do último serviço selecionado
    };
  }
  componentDidMount() {
    this.consultProcedures();
    // registrar listener para scroll/resize para detectar quando o usuário chega ao fim da lista
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.handleScroll);
    // checar o estado inicial (após render)
    setTimeout(this.handleScroll, 0);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.handleScroll);
    if (this.filterTimeout) clearTimeout(this.filterTimeout);
  }
  consultProcedures = async () => {
    const { myParam, nameProcedure } = this.state;
    await axios
      .get(`${URL_PreScheduling}/GetProcedures`, {
        params: {
          aliasClinic: myParam,
          nameProcedure: nameProcedure,
        },
      })
      .then((resp) => {
        const { data } = resp;
        this.setState({
          listProcedures: data,
          originalProcedures: data,
          loading: false,
        });
      });
  };
  consultProcedureLength = (e) => {
    // Atualiza o termo imediatamente e filtra com debounce para reduzir computação durante digitação rápida
    this.setState({ nameProcedure: e });
    if (this.filterTimeout) clearTimeout(this.filterTimeout);
    this.filterTimeout = setTimeout(() => {
      this.filterProcedures(e);
    }, 250);
  };

  // Filtra a lista local (prioriza itens que começam com o termo)
  filterProcedures = (term) => {
    try {
      const orig = this.state.originalProcedures || [];
      if (!term || term.trim() === "") {
        this.setState({ listProcedures: orig });
        return;
      }
      const lower = term.toString().toLowerCase();
      // itens que começam com o termo
      const starts = orig.filter((p) => {
        const desc = (p.description || "").toString().toLowerCase();
        return desc.startsWith(lower);
      });
      // itens que contêm o termo, mas não começam com ele
      const contains = orig.filter((p) => {
        const desc = (p.description || "").toString().toLowerCase();
        return desc.includes(lower) && !desc.startsWith(lower);
      });
      const result = [...starts, ...contains];
      // se não encontrar por description, tentar por value ou outro campo
      if (result.length === 0) {
        const fallback = orig.filter((p) => {
          const value = (p.value || "").toString().toLowerCase();
          return value.includes(lower);
        });
        this.setState({ listProcedures: fallback });
        return;
      }
      this.setState({ listProcedures: result });
    } catch (err) {
      // não bloquear a UI se algo falhar
    }
  };

  // Detecta se o container da lista atingiu o final (bottom visível na viewport)
  handleScroll = () => {
    try {
      const container = this.listContainerRef && this.listContainerRef.current;
      if (!container) return;
      const rect = container.getBoundingClientRect();
      // se a parte de baixo do container está visível na viewport -> estamos no fim da lista
      const isAtEnd =
        rect.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) + 8;
      if (isAtEnd !== this.state.isAtEnd) {
        this.setState({ isAtEnd });
      }
    } catch (err) {
      // não bloquear se algo falhar no cálculo
      // console.warn('handleScroll error', err);
    }
  };
  addService = (service, x) => {
    const { listProcedures, listChecked } = this.state;
    listProcedures.forEach((element) => {
      if (element.id == service.id) {
        element.checked = x.target.checked;
        if (x.target.checked) {
          let map = {
            idProcedure: element.id,
            value: element.value,
            redemptionPoints: element.redemptionPoints,
            loyaltyPoint: element.loyaltyPoints,
            duration: element.duration,
            description: element.description,
          };
          listChecked.push(map);
        } else {
          for (var i = 0; i < listChecked.length; i++) {
            if (listChecked[i].idProcedure === element.id) {
              listChecked.splice(i, 1);
            }
          }
        }
      }
    });
    let listProcedureId = [];
    listChecked.forEach((element) => {
      listProcedureId.push(element.idProcedure);
    });
    localStorage.setItem("listProcedureId", JSON.stringify(listProcedureId));
    localStorage.setItem("listProcedures", JSON.stringify(listChecked));

    // Verificar se há apenas 1 serviço com showOnSchedule === 1
    const displayableProceduresCount = listProcedures.filter(
      (p) => p.showOnSchedule === 1
    ).length;

    // Se há apenas um procedimento visível e foi marcado, ir direto para professionals
    if (x.target.checked && displayableProceduresCount === 1) {
      const { myParam } = this.state;
      window.location.href = myParam + "/professionals";
      return;
    }

    // Caso contrário, exibir o modal de ação
    const showActionCard = x.target.checked ? true : this.state.showActionCard;
    const lastSelectedService = x.target.checked
      ? service.description
      : this.state.lastSelectedService;

    this.setState({
      listProcedures,
      listChecked: listChecked,
      showActionCard,
      lastSelectedService,
    });
  };

  handleActionChoice = (choice) => {
    const { myParam } = this.state;
    if (choice === "schedule") {
      // Navega para a próxima etapa mantendo a seleção atual
      window.location.href = myParam + "/professionals";
      return;
    }
    // Continuar selecionando: apenas fecha o card
    this.setState({ showActionCard: false });
  };
  render() {
    const { listProcedures, myParam, loading, listChecked, isAtEnd } =
      this.state;

    return (
      <div>
        {loading ? (
          <div className="text-center mt-5">
            <FaSpinner color={"blue"} className="icon_pulse" />
          </div>
        ) : (
          <div>
            <div style={styles.searchRow}>
              <div style={styles.searchColumn}>
                <div style={styles.searchWrapper}>
                  <input
                    onChange={(e) =>
                      this.consultProcedureLength(e.target.value)
                    }
                    type="text"
                    placeholder="Pesquisar..."
                    style={styles.searchInput}
                  />
                  <span style={styles.searchIconWrapper}>
                    <FiSearch style={styles.searchIcon} />
                  </span>
                </div>
              </div>
              <div style={styles.actionButtonsRow}>
                <div className="">
                  <Button
                    href={myParam + "/insertphonepage"}
                    style={styles.btnCalendar}
                  >
                    <FiCalendar size={18} color="white" />
                  </Button>
                </div>
                <div className="">
                  <Button
                    style={styles.btnLocation}
                    href={myParam + "/location"}
                  >
                    <FiMapPin size={17} color="white" />
                  </Button>
                </div>
              </div>
            </div>
            <div style={styles.listContainer} ref={this.listContainerRef}>
              {listProcedures.length > 0 ? (
                <div>
                  <div className="" style={styles.servicesGrid}>
                    {listProcedures.map((e) =>
                      e.showOnSchedule > 0 ? (
                        <div
                          key={e.id}
                          className="service-item"
                          style={styles.serviceItem}
                        >
                          <div style={styles.serviceCard}>
                            {e.thumbFile != null ? (
                              <img
                                width={100}
                                height={100}
                                className="mb-1 img-fluid rounded-circle thumb75"
                                src={"data:image/png;base64," + e.thumbFile}
                                alt="Contact"
                                style={styles.thumbStyle}
                              />
                            ) : (
                              <img
                                width={100}
                                height={100}
                                className="mb-1 img-fluid rounded-circle thumb75"
                                src="/Image/nophotoservice.png"
                                alt="Contact"
                                style={styles.thumbStyle}
                              />
                            )}

                            <div style={styles.serviceTitle}>
                              {e.description}
                            </div>
                            <div style={styles.serviceMeta}>
                              {e.duration > 0 ? (
                                <div style={styles.durationRow}>
                                  <FiClock style={styles.clockIcon} />
                                  {` ${e.duration} minutos`}
                                </div>
                              ) : null}
                              {e.note == undefined ? null : (
                                <div style={styles.serviceNote}>{e.note}</div>
                              )}
                            </div>
                            <div style={styles.priceRow}>
                              <div key={e.id} style={styles.checkboxRow}>
                                <Label style={styles.labelText}>
                                  <Input
                                    color="dark"
                                    style={styles.checkboxInput}
                                    type="checkbox"
                                    onChange={(x) => this.addService(e, x)}
                                    checked={e.checked ?? false}
                                  />
                                  {e.displayValue
                                    ? e.value.toLocaleString("pt-br", {
                                        style: "currency",
                                        currency: "BRL",
                                      })
                                    : null}
                                </Label>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : null
                    )}
                  </div>
                  {/* Botão flutuante removido: ação agora está no card/modal */}
                </div>
              ) : (
                <Row>
                  <Col className="text-center mt-3">
                    <small
                      style={styles.noResultsStyle}
                      className="text-danger "
                    >
                      Serviços não localizados!
                    </small>
                  </Col>
                </Row>
              )}
            </div>
            {this.state.showActionCard && (
              <ScheduleOrContinueModal
                selectedServices={this.state.listChecked}
                displayableProceduresCount={
                  this.state.listProcedures.filter(
                    (p) => p.showOnSchedule === 1
                  ).length
                }
                onChoose={this.handleActionChoice}
              />
            )}
          </div>
        )}
      </div>
    );
  }
}
